import ComboBoxCourses from './combo-box-courses'

export default ComboBoxCourses
